import { render } from "./right-sidebar.vue?vue&type=template&id=36e50663&scoped=true"
import script from "./right-sidebar.vue?vue&type=script&lang=js"
export * from "./right-sidebar.vue?vue&type=script&lang=js"

import "./right-sidebar.vue?vue&type=style&index=0&id=36e50663&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e50663"]])

export default __exports__